import React from 'react'
import clsx from 'clsx'

export default function TaskItem({
  disabled = false,
  iconClassName,
  title,
  subTitle,
  btnTitle,
  onSubmit,
  submitBtnClasses = 'dome-btn dome-btn-base dome-btn-grey-stroke',
}) {
  return (
    <div
      style={{ padding: 6, width: '100%' }}
      className={clsx('auto-questionnaire-processor-task-section', { 'disabled': disabled })}
      ref={(node) => node && (disabled ? node.setAttribute('inert', '') : node.removeAttribute('inert'))}
    >
      <div className="dome-d-flex dome-gap18 dome-align-center">
        <div className="dome-flex-1">
          <div className="dome-d-flex dome-gap6">
            <span style={{ flexBasis: '17.5px' }}>
              <i className={iconClassName}></i>
            </span>
            <div className="dome-d-flex dome-flex-column">
              <span className="dome-p2 dome-color-dark-grey dome-text-w500"> {title}</span>
              <span className="dome-p3 dome-color-med-grey">{subTitle}</span>
            </div>
          </div>
        </div>
        <button
          type="button"
          onClick={onSubmit}
          className={clsx(submitBtnClasses, disabled && 'dome-btn-disabled')}
        >
          {btnTitle}
        </button>
      </div>
    </div>
  )
}
